import { Route, Simulation } from '@helpers/types.ts';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { chain } from 'lodash';
import { FC } from 'react';

import { RouteCard } from './route-card.tsx';

interface IRouteCardsListProps {
  plan: Simulation | undefined;
  selected: Array<string>;
  onToggleAll: () => void;
  onSplit: (route: Route) => void;
  onToggleSelection: (route: string) => void;
  onStartDisableRoute: (route: string) => void;
  focusRoute: (route: Array<string>) => void;
}

export const RouteCardsList: FC<IRouteCardsListProps> = (props) => {
  return (
    <div className="h-[calc(100vh-128px)] overflow-auto p-3 pb-12">
      <div className="flex items-center justify-between mb-3 z-10 py-2">
        <Typography variant="subtitle2" fontWeight="bold">
          Rutas ({props.plan?.routes.length ?? 0})
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={props.selected.length === props.plan?.routes?.length}
              onChange={props.onToggleAll}
            />
          }
          label={<Typography variant="caption">Seleccionar todas</Typography>}
          labelPlacement="start"
        />
      </div>
      <div className="flex flex-col gap-3">
        {chain(props.plan?.routes)
          .sortBy('name')
          .map((route) => (
            <RouteCard
              key={route.id}
              route={route}
              plan={props.plan}
              selected={props.selected.includes(route.id)}
              onToggleSelection={props.onToggleSelection}
              onSplit={props.onSplit}
              onStartDisableRoute={props.onStartDisableRoute}
              focusRoute={props.focusRoute}
            />
          ))
          .value()}
      </div>
    </div>
  );
};
